import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-sign-in-instructor',
  templateUrl: './sign-in-instructor.component.html',
  styleUrls: ['./sign-in-instructor.component.css']
})
export class SignInInstructorComponent implements OnInit {

  constructor(
    public authService: AuthService,
  ) { }

  ngOnInit(): void {
  }

}
